import React from 'react'
import './App.css'
import Navbar from './components/Navbar'
import { Routes, Route } from 'react-router-dom'
import ProfilePage from './pages/Profile'
import LikedPage from './pages/Liked'
import UploadPage from './pages/Upload'
import SongsPage from './pages/Songs'
import TranscodingStatusPage from './pages/TranscodingStatus'
import MemoryGame from './components/MemoryGame'
import GameAdminPage from './pages/GameAdmin'

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Routes>
          <Route
            path="/"
            element={<MemoryGame />}
          />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/liked" element={<LikedPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/transcoding" element={<TranscodingStatusPage />} />
          <Route path="/songs" element={<SongsPage />} />
          <Route path="/game-admin" element={<GameAdminPage />} />
          <Route
            path="/you"
            element={
              <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}>
                <h2>This is the You page</h2>
              </div>
            }
          />
        </Routes>
      </main>
    </div>
  )
}

export default App
